import { ApplicationWorkAndIncomeScreen } from "@/interactors/ApplicationWorkAndIncomeScreen";

export default function WorkAndIncome() {
  return <ApplicationWorkAndIncomeScreen />;
}
